module.exports = __webpack_public_path__ + "static/media/to.c43358cb.svg";